import { TaxSummaryType } from './tax-summary-type';

export class TaxSummaryDetail {
  taxSummaryId!: number;
  countryId!: number;
  taxSummaryType!: TaxSummaryType;
  header!: TaxSummaryType;
  isActive!: boolean;
  isApproved!: boolean;
  description!: string;
  reviewDate?: Date;
}
